import { createPortal } from "react-dom";

import { useCustomCursor } from "@/hooks/useCustomCursor";

export default function CustomCursor() {
  const { enabled, visible, point } = useCustomCursor();

  if (!enabled) return null;

  return createPortal(
    <div
      className={`custom-cursor${visible ? " custom-cursor--visible" : ""}`}
      style={{ left: point.x, top: point.y }}
      aria-hidden="true"
    />,
    document.body,
  );
}
